import parseCookies from '../lib/cookie/parser';
import createUserProfileFrom from '../lib/cookie/user/profile';

const getUserProfile = () => {
  const cookies = parseCookies();
  return createUserProfileFrom(cookies);
};

export default getUserProfile;
